import React from 'react';
import { Pane, Button, Spinner, Text, Badge, SearchIcon } from 'evergreen-ui';

export const SearchBar = ({ searchQuery, setSearchQuery, isSearching, searchResults }) => {
  const totalResults = Object.values(searchResults).reduce((sum, arr) => sum + arr.length, 0);

  return (
    <Pane 
      padding={24} 
      paddingBottom={16}
      borderBottom="1px solid #E6E8F0"
      background="white"
    >
      <Pane display="flex" alignItems="center" gap={16}>
        <Pane flex={1} position="relative">
          <SearchIcon 
            size={16} 
            color="muted" 
            position="absolute" 
            left={12} 
            top="50%" 
            transform="translateY(-50%)"
          />
          <input
            type="text"
            placeholder="Search across all results (IPs, domains, services, findings...)"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            style={{
              width: '100%',
              padding: '12px 12px 12px 40px',
              border: '1px solid #E6E8F0',
              borderRadius: '6px',
              fontSize: '14px',
              outline: 'none',
              transition: 'border-color 0.2s'
            }}
            onFocus={(e) => e.target.style.borderColor = '#1070CA'}
            onBlur={(e) => e.target.style.borderColor = '#E6E8F0'}
          />
          {isSearching && (
            <Spinner 
              size={16} 
              position="absolute" 
              right={12} 
              top="50%" 
              transform="translateY(-50%)"
            />
          )}
        </Pane>
        {searchQuery && (
          <Button
            size="small"
            appearance="minimal"
            onClick={() => setSearchQuery('')}
          >
            Clear
          </Button>
        )}
      </Pane>
      
      {searchQuery && (
        <Pane marginTop={12} display="flex" alignItems="center" gap={8}>
          {isSearching ? (
            <Spinner size={16} />
          ) : (
            <Text size={300} color="muted">
              Found {totalResults} results across all tabs
            </Text>
          )}
        </Pane>
      )}
    </Pane>
  );
};

